<template>
    <div>
        <router-link to="/shopinfo">
            <h3 class="big-title">返回 信息发布>>{{m.title}}</h3>
        </router-link>
        <pre class="content" v-html="m.content"></pre>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                id: "",
                m: {}
            };
        },
        created() {
            // 在组件实例处理完所有与状态相关的选项后调用。
        },
        mounted() {
            // 在组件被挂载之后调用。
            this.id = this.$route.query.id;
            let list = this.$y_getKey('queList');
            this.m = list[this.id]
        },
        methods: {

        },
    };
</script>
<style lang="less" scoped>
    .content {
        line-height: 1.5;
        font-size: 16px;
        white-space: pre-wrap;
        word-wrap: break-word;
    }

    /* 移动端 */
    @media (max-width: 600px) {
        .content {
            width: 90vw;
            margin-left: 5vw;
        }
    }
</style>